import { StatsigState } from "@fitness-force/models";


export const StatsigInitialState: StatsigState = {
  user:null,
};
